import React from "react";

const ShimmerUi = ({ count = 10 }) => {
  return (
    <div className="flex justify-start items-center flex-wrap p-3 w-full animate-pulse">
      {[...Array(count)].map((_, index) => (
        <div
          key={index}
          className="flex flex-col w-[280px] h-[288px] bg-white my-3 mx-4 p-2 rounded-lg shadow-md"
        >
          <div className="w-[260px] h-[186px] bg-gray-200 rounded-xl" />
          <div className="h-5 bg-gray-200 rounded w-3/4 mt-3" />
          <div className="flex items-center mt-3">
            <div className="w-5 h-5 bg-gray-200 rounded-full mr-2" />
            <div className="h-4 bg-gray-200 rounded w-1/2" />
          </div>
        </div>
      ))}
    </div>
  );
};

export default ShimmerUi;